import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpenseReturn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: .373047,
			width: 15.9963,
			height: 16,
			rx: 7.99817,
			fill: "#DC3636"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1973 8.33203L5.19864 8.33203",
			stroke: "white",
			strokeWidth: .599862,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.59863 11.1309L4.79927 8.33158L7.59863 5.53223",
			stroke: "white",
			strokeWidth: .599862,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})
	]
});
export default SvgExpenseReturn;
